import React, { useEffect, useState } from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'

const __dayoffset = 1000 * 60 * 60 * 24, __houroffset = 1000 * 60 * 60, __minuteoffset = 1000 * 60
const getFullNumber = (number) => number >= 10 ? number : ('0' + number)

const CountDown = class extends React.Component {
	constructor (props) {
		super(props)
		this.state = {
			lefting: 0
		}
	}

	getStructeDate (lefting) {
		lefting = lefting 
		const day = Math.floor(lefting / __dayoffset)
		const _leftday = lefting % __dayoffset
		let hour = this.props.showDay ? Math.floor(_leftday / __houroffset) : Math.floor(lefting / __houroffset)
		const _lefthour = lefting % __houroffset
		const minute = Math.floor(_lefthour / __minuteoffset)
		const second = Math.floor((lefting % __minuteoffset) / 1000)

		return {
			day: getFullNumber(day),
			hour: getFullNumber(hour),
			minute: getFullNumber(minute),
			second: getFullNumber(second)
		}
	}

	componentDidMount () {
		const { offset } = this.props
		this.setState({
			lefting: offset
		})
		this.timerID = setInterval(() => {
			if (this.state.lefting - 1000 < 0) {
				clearInterval(this.timerID)
			} else {
				this.setState({
					lefting: this.state.lefting - 1000
				})
			}
		}, 1000)
	}

	componentWillUnmount () {
		clearInterval(this.timerID)
	}

	render () {
		const {day, hour, minute, second} = this.getStructeDate(this.state.lefting)
		// console.log(day, hour, minute, second)
		const {showDay, showHour} = this.props
		return <span {...this.props}>
			{showDay && <React.Fragment><span>{day}</span><span>:</span></React.Fragment>}
			{showHour && <React.Fragment><span>{hour}</span><span>:</span></React.Fragment>}
			<span>{minute}</span><span>:</span>
			<span>{second}</span>
		</span>
	}
}

export default CountDown